import { type CustomTooltipProps } from "ag-grid-react"

import { IncomingStockCard } from "~/components/purchaseOrder/incomingOrders/IncomingStockCard"
import { Card } from "~/components/reusable/Card"

import HeaderTooltip from "./HeaderTooltip"

const IncomingStockTooltip = (props: CustomTooltipProps) => {
  if (props.location === "header") {
    return <HeaderTooltip {...props} />
  }
  const variantIds = props.node?.group ? props.value.variantIds : [props.data.variantId]
  const skuIds = props.node?.group ? undefined : props.data.skuIds

  let dateRange: { start: Date; end: Date } | undefined

  if (props.value.startDate && props.value.endDate) {
    dateRange = { start: props.value.startDate, end: props.value.endDate }
  }

  return (
    <Card className="w-full">
      <IncomingStockCard variantIds={variantIds} skuIds={skuIds} dateRange={dateRange} />
    </Card>
  )
}

export default IncomingStockTooltip
